import { ICategoryState, ICategoryStateFulfilled, IStateRejected } from '../../interfaces';
import { categoryAction } from '../actions';

const findAllCategory = () => {
  const { pending, fulfilled, rejected } = categoryAction.findAllCategory;
  return {
    // Pending
    [pending.type]: (state: ICategoryState): ICategoryState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (_: ICategoryState, action: ICategoryStateFulfilled): ICategoryState => ({
      status: 'success',
      categories: action.payload,
      error: '',
    }),
    // Rejected
    [rejected.type]: (_: ICategoryState, action: IStateRejected): ICategoryState => ({
      categories: [],
      status: 'error',
      error: action.error.message,
    }),
  };
};

export default {
  ...findAllCategory(),
};
